import clsx from 'clsx';
import React, { useState, useRef } from 'react';
import axios from 'axios';

const securityString = 'ote-potwierdzam-usuniecie';

const AccountDeleteModal = () => {
  const self = useRef();
  const [input, setInput] = useState('');
  const [hasInputError, setHasInputError] = useState(false);

  const handleConfirm = (event) => {
    if (input !== securityString) {
      setHasInputError(true);
    } else {
      setHasInputError(false);
      setInput('');
      axios.delete(window.DjUrls['users:delete-self']());
      window.location.href = '/';
    }
  };
  const handleCancel = () => {
    setInput('');
    setHasInputError(false);
  };

  return (
    <dialog id="dlt-confirm-modal" className="modal" ref={self}>
      <div className="modal-box">
        <h2 className="text-2xl font-bold">
          Czy na pewno chcesz usunąć konto?
        </h2>
        <p className="py-4 text-error">
          <span className="font-semibold">Uwaga!</span> Operacja ta jest
          nieodwracalna i spowoduje usunięcie wszystkich zasobów powiązanych z
          kontem.
        </p>
        <p className="py-4">
          Aby kontynuować wpisz:{' '}
          <span className="italic">{securityString}</span>
        </p>
        <input
          type="text"
          className={clsx(
            'input input-bordered w-full max-w-xs',
            hasInputError && 'border-error',
          )}
          id="dlt-confirm-text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onFocus={() => setHasInputError(false)}
        />
        {hasInputError && (
          <p className="text-error">Wpisano niepoprawną wartość</p>
        )}
        <div className="modal-action flex justify-between">
          <form method="dialog">
            <button className="btn btn-secondary" onClick={handleCancel}>
              Anuluj
            </button>
          </form>
          <button className="btn btn-warning" onClick={handleConfirm}>
            Usuń
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default AccountDeleteModal;
